"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*eslint-disable */
var _default = {
  name: 'LONG_ARROW_RIGHT_LINE',
  path: 'M16 8l-.706.707 2.792 2.792H4v1h14.086l-2.792 2.794.707.706 4-3.998L16.003 8z',
  viewBox: '0 0 24 24',
  invert: false
};
/*eslint-enable */

exports["default"] = _default;